import { Component, input, InputSignal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SectionCardInterface } from '../../data/interfaces/SectionCardInterface';

@Component({
  selector: 'app-section-card',
  imports: [FontAwesomeModule],
  templateUrl: './section-card.html',
  styleUrl: './section-card.scss',
})
export class SectionCard {
  type = input<string>('public-security')

  card: InputSignal<SectionCardInterface> = input<SectionCardInterface>({
    title: 'titulo',
    link: '#',
    imgLink: 'assets/section-card-1.jpg'
  }
) 
}
